import React, { useEffect } from "react"
import { navigate, Link } from "gatsby"

import Seo from "../components/seo"

export default () => {
	useEffect(() => {
		navigate("/")
	}, [])

	return <>
		<Seo title={"Page Not Found"} description={"Page Not Found"} meta={[{name: `robots`, content: `noindex`}]} />
		<div className="margin-content text-centered">
			<br/>
			<br/>
			<h1>Page Not Found</h1>
			<br/>
			<br/>
			<Link style={{"textDecoration":"underline"}} to="/">Click here to go to home page</Link>
		</div>

	</>
}
